import {SIGN_IN, GETUSER, GETALLUSER, GETINFOONEUSER, PAGINATIONUSER, GETUSERFILTER} from '../actions/constant';

const INITIAL_STATE = {user_token: {}, user_detail: {}, user_all: {}, user_edit: {}, error: ''};

export default function (state = INITIAL_STATE, action) {
    switch (action.type){
        case SIGN_IN:
            return {...state, user_token: action.payload.data, error: action.payload.error_signIn };
        case GETUSER:
            return {...state, user_detail: action.payload.data};
        case GETALLUSER:
            return {...state, user_all: action.payload.data};
        case GETUSERFILTER:
            return {...state, user_all: action.payload.data};
        case GETINFOONEUSER:
            return {...state, user_edit: action.payload.data};
        case PAGINATIONUSER:
            return {...state, user_all: action.payload.data};
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_signIn.js